import React, { useState } from "react";
import PropTypes from "prop-types";
import { IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";
import ServiceStats from "./sub/ServiceStats";
import PointStats from "./sub/PointStats";

import "./style/MatchStatistics.scss";
import StackedBarChart from "../StackedBarChart/StackedBarChart";
import PointsDistributionChart from "./sub/PointsDistributionChart";
import ResultDistributionChart from "./sub/ResultDistributionChart";
import TotalPointsDistributionChart from "./sub/TotalPointsDistributionChart";

function MatchStatistics({ data }) {
  console.log("MatchStatistics", data);
  const players = [...data.team_a, ...data.team_b];
  const [selectedPlayer, setSelectedPlayer] = useState(players[0].athleteId);
  const currentPlayerTeam = data.team_a.some(
    (player) => player.athleteId === selectedPlayer,
  )
    ? "team_a"
    : "team_b";

  const againstTeam =
    currentPlayerTeam === "team_a" ? data.team_b : data.team_a;

  const againstPlayerStats = againstTeam.map((player) => {
    return {
      player,
      stats: data.statistics.total[player.athleteId],
    };
  });

  return (
    <div>
      <IonSegment
        value={selectedPlayer}
        onIonChange={(e) => setSelectedPlayer(e.detail.value)}
      >
        {players.map((player) => (
          <IonSegmentButton key={player.athleteId} value={player.athleteId}>
            <IonLabel>{player.name}</IonLabel>
          </IonSegmentButton>
        ))}
      </IonSegment>
      <ServiceStats
        servingPlayerStats={data.statistics.total[selectedPlayer]}
        receveingPlayerStats={againstPlayerStats}
      />
      <PointStats data={data.statistics.total[selectedPlayer].points} />
      <div
        className="ion-padding"
        style={{ height: "500px", width: "100%", position: "relative" }}
      >
        <PointsDistributionChart
          stats={data.statistics.total[selectedPlayer].points}
        />
      </div>
      <div
        className="ion-padding"
        style={{ height: "500px", width: "100%", position: "relative" }}
      >
        <ResultDistributionChart
          stats={data.statistics.total[selectedPlayer].points}
        />
      </div>
      <div
        className="ion-padding"
        style={{ height: "500px", width: "100%", position: "relative" }}
      >
        <TotalPointsDistributionChart
          stats={data.statistics.total[selectedPlayer].points}
          otherPlayerStats={againstPlayerStats}
        />
      </div>
    </div>
  );
}

MatchStatistics.propTypes = {
  data: PropTypes.shape({
    team_a: PropTypes.arrayOf(
      PropTypes.shape({
        athleteId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ).isRequired,
    team_b: PropTypes.arrayOf(
      PropTypes.shape({
        athleteId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ).isRequired,
    statistics: PropTypes.shape({
      total: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
};

export default MatchStatistics;
